module.exports = __webpack_public_path__ + "static/media/miterWrong.be38ab24.png";